export class MedicalHistoryModel {
  resultid : string;
  problem: string;
  patientNote: string;
  validvalueId: string;
  enumFormControlID: string;
  dataFormItemId: string;
  ItemOrder: number;
}
